import { useCallback } from 'react';

const useMessageFeedback = ({ normalizedBotId, orgId }) => {
    const apiUrl = process.env.REACT_APP_API_URL;
    const apiKey = process.env.REACT_APP_BOT_API_KEY;
    const feedbackAgentId = normalizedBotId
        ? (normalizedBotId.startsWith('bot_') ? normalizedBotId : `bot_${normalizedBotId}`)
        : '';

    const submitFeedback = useCallback(async (input) => {
        if (!apiUrl || !apiKey || !normalizedBotId || !feedbackAgentId) {
            return;
        }

        const chatId = input.conversationId || localStorage.getItem(`chatId_${normalizedBotId}`);

        const body = {
            agent_id: feedbackAgentId,
            conversation_id: chatId,
            org_id: orgId,
            feedback_type: input.feedbackType,
            user_message: input.userMessage || '',
            assistant_response: input.assistantResponse,
            assistant_message_id: input.assistantMessageId,
            meta_data: {
                source: 'widget',
            },
        };

        try {
            const response = await fetch(`${apiUrl}/api/feedback`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Api-token': apiKey,
                },
                signal: input.signal,
                body: JSON.stringify(body),
            });

            if (!response.ok) {
                throw new Error(`Feedback submission failed with status ${response.status}`);
            }

            return response;
        } catch (error) {
            if (error?.name !== 'AbortError') {
                console.error('Feedback submission failed:', error);
            }
            throw error;
        }
    }, [apiUrl, apiKey, normalizedBotId, feedbackAgentId, orgId]);

    return { submitFeedback };
};

export default useMessageFeedback;
